import { useEnsName } from "wagmi"

interface Props {
  address?: any
}

const Address = ({ address }: Props) => {
  const ensName = useEnsName({ address, chainId: 1 })
  const shortAddress = address ? `${address.slice(0, 6)}...${address.slice(38, 42)}` : null

  return address !== null ? (
    <span title={address} className="text-gallery-muted hover:text-gallery-text transition-colors cursor-default">
      {ensName.data || shortAddress}
    </span>
  ) : null
}

export default Address
